export enum CascadeTriggerMode {
  Click = 'click',
  Hover = 'hover'
}